import { Visit } from "@graphql";
import "./TodaysVisitors.css";
import React, { useEffect } from "react";
import { Icon } from "@fluentui/react";
import { visitorStatus } from "../shared/enums";
import { format } from "date-fns";
import ExpectedStatusIcon from "assets/svg/expected-status-icon";
import SignedInStatusIcon from "assets/svg/signed-in-status-icon";
import SignedOutStatusIcon from "assets/svg/signed-out-status-icon";

interface Props {
  visitors: Visit[];
}

const TodaysVisitors: React.FunctionComponent<Props> = (props: Props) => {
  const { visitors } = props;

  const getStatus = (signInStatus: string) => {
    switch (signInStatus) {
      case visitorStatus.Expected: {
        return (
          <>
            <div className="status">
              Expected
              <ExpectedStatusIcon className="status-icon"></ExpectedStatusIcon>
            </div>
          </>
        );
      }
      case visitorStatus.SignedIn: {
        return (
          <>
            <div className="status">
              Signed In
              <SignedInStatusIcon className="status-icon"></SignedInStatusIcon>
            </div>
          </>
        );
      }
      case visitorStatus.SignedOut: {
        return (
          <>
            <div className="status">
              Signed Out
              <SignedOutStatusIcon className="status-icon"></SignedOutStatusIcon>
            </div>
          </>
        );
      }
    }
  };

  return (
    <>
      {visitors?.length > 0 && (
        <>
          <div className="title">Today's Visitors</div>
          {visitors?.map((el) => (
            <div className="visitor-card" key={el._id}>
              <div className="visitors-name">
                {el.visitor?.firstName} {el.visitor?.lastName}
                <div className="company-name">{el.visitor?.company}</div>
              </div>

              {getStatus(el.signInStatus)}
              <div className="time">{format(new Date(el.expectedDate), "HH:mm")}</div>
            </div>
          ))}
        </>
      )}
    </>
  );
};

export default TodaysVisitors;
